import { FC } from 'react';

import Paper from '@mui/material/Paper';
import Breadcrumbs, { BreadcrumbsProps } from 'components/Breadcrumbs';
import Box from '@mui/material/Box';

import { PropType } from 'types/utils';
import { SxProps, Theme } from '@mui/material/styles';

type Props = {
  breadcrumbs: PropType<BreadcrumbsProps, 'breadcrumbs'>;
  sx?: SxProps<Theme>;
};

const Page: FC<Props> = ({ children, breadcrumbs, sx }) => (
  <Box sx={sx}>
    <Breadcrumbs breadcrumbs={breadcrumbs} />
    <Paper sx={{ p: 2 }}>{children}</Paper>
  </Box>
);

export default Page;
